




















import { computed, defineComponent } from '@vue/composition-api';
import { useNewProjectsStore } from '@/stores/new-project';

export default defineComponent({
  name: 'PublicFolderPath',
  setup() {
    const newProjectsStore = useNewProjectsStore();

    const path = computed(() => newProjectsStore.runtimeStep?.domainRootPath);

    const setRootPath = (path: string) => {
      newProjectsStore.setRuntimeDomainRootPath(path);
    };

    return {
      path,
      setRootPath,
    };
  },
});
